export enum PodcastEvent {
    SELECT_EPISODE = "selectEpisode",
    SELECT_SEASON = "selectSeason"
}